import { SearchBiography } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.SEARCHBIOGRAPHY.path,
      name: "Search Biography",
      key: routesMap.SEARCHBIOGRAPHY.path,
      commonRoute: true,
      private: false,
      // withAuth: true,
      // belongsToHeader: true,
      element: <SearchBiography />,
    }
  ];
}
